<h2 mat-dialog-title>{{ tituloTxt }}</h2>
<mat-dialog-content style="min-height: 100px">
  <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
    <input type="hidden" formControlName="id" value="" />
    <div 
    fxLayout="row wrap"
    fxLayout.xs="column"
    fxLayoutAlign.xs="space-around stretch"
    fxLayoutAlign.md="space-between center"
    fxLayoutAlign="space-between center"
    fxLayoutGap="5px"
    >

    <mat-form-field appearance="outline" class="example-full-width" fxFlex="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100">
      <mat-label>Nombre</mat-label>
      <input
        formControlName="nombre"
        matInput
        placeholder="Nombre del horario"
        value=""
      />
      <mat-error>El nombre es requerido</mat-error>
    </mat-form-field>

      <mat-form-field appearance="outline" class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-label>Disciplina</mat-label>
        <mat-select formControlName="disciplinaId">
          <mat-option
            *ngFor="let disciplinaTmp of lstDisciplinas"
            [value]="disciplinaTmp.id"
          >
            {{ disciplinaTmp.nombre }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-label>Club</mat-label>
        <mat-select  formControlName="empresaId">
          <mat-option *ngFor="let clubTmp of lstClubes" [value]="clubTmp.id">
            {{clubTmp.nombre}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-label>Hora inicial</mat-label>
        <input
          formControlName="horaInicio"
          matInput
          placeholder="Hora de inicio del horario"
          value=""
          type="time"
        />
        <mat-error>La hora inicial es requerida</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-label>Hora final</mat-label>
        <input
          formControlName="horaFin"
          matInput
          placeholder="Hora final del horario"
          value=""
          type="time"
        />
        <mat-error>La hora final es requerida</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-label>Aforo máximo</mat-label>
        <input
          formControlName="aforo"
          matInput
          placeholder="Capacidad máxima de ingresos diarios"
          min="0"
          type="number"
        />
        <mat-error>La hora final es requerida</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-label>Piscina</mat-label>
        <mat-select formControlName="piscina">
          <mat-option value="0">50 Metros</mat-option>
          <mat-option value="1">Clavados</mat-option>
          <mat-option value="2">Rugby</mat-option>
        </mat-select>
      </mat-form-field>

      <div style="width: 100%; height: 1px; background-color: rgb(209 209 209 / 40%); margin-bottom: 20px"></div>

      <div class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-slide-toggle class="example-margin" formControlName="lunes">
          Lunes
        </mat-slide-toggle>
      </div>

      <div class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-slide-toggle class="example-margin" formControlName="martes">
          Martes
        </mat-slide-toggle>
      </div>

      <div class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-slide-toggle class="example-margin" formControlName="miercoles">
          Miercoles
        </mat-slide-toggle>
      </div>

      <div class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-slide-toggle class="example-margin" formControlName="jueves">
          Jueves
        </mat-slide-toggle>
      </div>

      <div class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-slide-toggle class="example-margin" formControlName="viernes">
          Viernes
        </mat-slide-toggle>
      </div>

      <div class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-slide-toggle class="example-margin" formControlName="sabado">
          Sabado
        </mat-slide-toggle>
      </div>

           <div class="example-full-width" fxFlex="45" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="45" fxFlex.xl="45">
        <mat-slide-toggle class="example-margin" formControlName="domingo">
          Domingo
        </mat-slide-toggle>
      </div>

      <div class="example-full-width" fxFlex="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100">
        <mat-slide-toggle class="example-margin" formControlName="habilitado">
          Habilitado
        </mat-slide-toggle>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="submit"
    mat-button
    mat-flat-button
    color="primary"
    (click)="guardar()"
    [disabled]="registerForm.invalid"
  >
    Guardar
  </button>

<!--   <button
  type="button"
  mat-button
  mat-flat-button
  color="primary"
  (click)="estado()"
>
  estado
</button> -->
  <button mat-button mat-dialog-close="false">Cancelar</button>
</mat-dialog-actions>

<!-- mat-dialog-close='false' -->
